import { useMemo, useState } from 'react';
import { Box, Divider, useTheme, withStyles } from '@material-ui/core';
import { Product } from '@setvi/shared/interfaces';
import { ProductsListProps } from 'pages/products/components';
import { SButton, SSearchInput } from '@setvi/shared/components';
import { handleStaticSearchProducts } from 'pages/products/components/products-list/components';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { EmailIcon } from '@setvi/shared/components/sicons';
import { DrawerHeaderTitle } from '../../components';
import { Wrapper } from '../../../header/content/styled';
import {
  MobileProductCardProps,
  MobileProductListCard
} from '../../../list/components';

const StyledButton = withStyles({
  root: {
    borderRadius: 120
  }
})(SButton);

const ListContainer = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '8px',
    overflow: 'auto',
    flex: 1,
    padding: '12px 20px',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  }
}))(Box);

interface MobileEmailSelectedProps
  extends Pick<
    MobileProductCardProps,
    'filters' | 'gridConfig' | 'priceType' | 'aiSearchActive'
  > {
  selected: Product[];
  handleSelect: ProductsListProps['handleProductSelect'];
  handleEmail: () => void;
  handleClear: () => void;
  handleClose: () => void;
}
export const MobileEmailSelected = ({
  selected,
  priceType,
  gridConfig,
  filters,
  handleEmail,
  handleSelect,
  handleClose,
  handleClear
}: MobileEmailSelectedProps) => {
  const [search, setSearch] = useState('');
  const { palette } = useTheme();

  const list = useMemo(
    () => handleStaticSearchProducts(selected, search),
    [selected, search]
  );

  return (
    <Box height="100%" display="flex" flexDirection="column" overflow="hidden">
      <Wrapper px="20px" pt="20px">
        <DrawerHeaderTitle
          handleClose={handleClose}
          title={`Selected Products (${selected.length})`}
        />
        <SButton
          variant="text"
          onClick={handleClear}
          style={{ minHeight: 'auto', padding: 0 }}>
          Clear All
        </SButton>
      </Wrapper>
      <Box px="20px">
        <SSearchInput
          onChange={val => setSearch(val)}
          placeholder="Search selected products..."
          style={{
            width: '100%',
            padding: '8px 12px',
            borderRadius: 99,
            margin: `16px 0`,
            height: 40
          }}
        />
      </Box>
      <ListContainer>
        {list?.length ? (
          list.map(i => (
            <MobileProductListCard
              product={i}
              priceType={priceType}
              gridConfig={gridConfig}
              checked
              filters={filters}
              handleCheck={(isChecked, product) => {
                handleSelect(isChecked, product);
                if (selected.length === 1) handleClose();
              }}
              style={{ width: 'auto' }}
            />
          ))
        ) : (
          <ProductsEmptyState title="No products found" />
        )}
      </ListContainer>
      <Divider />
      <Box p="20px" style={{ backgroundColor: palette.common.white }}>
        <StyledButton
          variant="outlined"
          fullWidth
          onClick={handleClose}
          style={{ marginBottom: 12 }}>
          Cancel
        </StyledButton>
        <StyledButton
          startIcon={<EmailIcon fill={palette.common.white} />}
          variant="contained"
          fullWidth
          onClick={handleEmail}>
          Send Email
        </StyledButton>
      </Box>
    </Box>
  );
};
